export default __webpack_public_path__ + "static/media/screenshot12.79cbfa71.jpg";